<script setup lang="ts">
import { useRouterStore } from '@/stores/router'
import { pinia } from '@/stores'
import { storeToRefs } from 'pinia'
import { computed, onMounted, ref } from 'vue'
import { getLimitDate } from '@/utils/limit-date'
import { getStore } from '@/utils/remote-diagnose'
import { useRemoteDiagnose } from '@/stores/remote-diagnose'

defineProps({
  aws_url: {
    type: String,
    required: true
  },
  stripe_key: {
    type: String,
    required: true
  },
  erpnext_url: {
    type: String,
    required: true
  },
  revolut_mode: {
    type: String,
    required: true,
    default: 'prod'
  }
})

const routerStore = useRouterStore(pinia)
const remoteDiagnoseStore = useRemoteDiagnose(pinia)

const { validateParams, back, push } = routerStore

const { current } = storeToRefs(routerStore)
const { state } = storeToRefs(remoteDiagnoseStore)

const appContainer = ref<HTMLElement | null>(null)

const showArrowBack = computed(() => {
  const excludedRoutes = ['payment', 'payment-success', 'timesup', 'payment-revolut'];
  return !!(
  current.value.lastView.length && 
  !excludedRoutes.includes(current.value.name)
);
})

const scrollToTop = () => {
  if (appContainer.value) {
    appContainer.value.scrollIntoView({ behavior: 'smooth' })
  }
}

onMounted(() => {
  const url = new URL(`${window.location}`)
  validateParams(url.search.slice(1))

  const savedStore = getStore()
  if (savedStore) {
    state.value = savedStore

    if (current.value.name !== 'payment-success') {
      push('address')
    }
  }

  if (!url.searchParams.get('redirect_status')) {
    if (getLimitDate()) {
      const path = state.value.payment_gateway === 'stripe' ? 'payment' : 'payment-revolut'
      push(path)
    }
  }
})
</script>

<template>
  <div ref="appContainer" class="relative min-h-80 rounded p-10 mx-auto">
    <button v-if="showArrowBack" @click="back">
      <img alt="Back icon" src="@/assets/icons/back.svg" width="24" height="24" />
    </button>
    <component
      :is="current.component"
      :aws_url="aws_url"
      :stripe_key="stripe_key"
      :erpnext_url="erpnext_url"
      :revolut_mode="revolut_mode"
      @scroll="scrollToTop"
    >
      <slot></slot>
    </component>
  </div>
</template>
